import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const monthlyReportsManagement = createApi({
    reducerPath: "monthlyReportsManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        monthlyReportsList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/monthly-reports`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewMonthlyReports: builder.mutation({
            query: (reportId) => ({
                url: `v1/${locale}/settings/monthly-reports/${reportId}`,
                method: "GET",
            }),
        }),

        addMonthlyReports: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/monthly-reports`,
                method: "POST",
                body: body,
            }),
        }),

        updateMonthlyReports: builder.mutation({
            query: ({ body, reportId }) => ({
                url: `v1/${locale}/settings/monthly-reports/${reportId}`,
                method: "PATCH",
                body: body,
            }),
        }),

        deleteMonthlyReports: builder.mutation({
            query: (reportId) => ({
                url: `v1/${locale}/settings/monthly-reports/${reportId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const { useMonthlyReportsListMutation, useDeleteMonthlyReportsMutation, useAddMonthlyReportsMutation, useViewMonthlyReportsMutation, useUpdateMonthlyReportsMutation } = monthlyReportsManagement;
